import React, { useState, useEffect, useRef } from "react";
import '../css/customModalMovementsInfo.css'
import { useTabletMediaQuery, useMobileMediaQuery } from '../utils';
import Modal from 'react-bootstrap/Modal';
import CustomButton from "./CustomButton";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { GoDotFill } from "react-icons/go";
import { IoMdClose } from "react-icons/io";

const CustomModalMovementsInfo = (props) => {
    let {
        txtAlert = '',
        date = '',
        title = '',
        partnerName = '',
        amountAcumulated = '',
        amountPaid = '',
        isPending = '',
        txtDetalhe = '',
        txtPromoCode = '',
        txtDetalheCupao = '',
        txtDetalheMP = '',
        movPlataforma = '',
        movEncomenda = '',
        iTransferencia = 'N'
    } = props;

    txtPromoCode = txtPromoCode || '';
    if (title === 'Dedução' || title === 'Expiração' || title === 'Dedução pendente' || title === 'Devolução') {
        txtPromoCode = '';
    }

    const isTablet = useTabletMediaQuery();
    const isMobile = useMobileMediaQuery();
    
    const [showAlert, setShowAlert] = useState(false)
    const [showAlertPend, setShowAlertPend] = useState(false)
    const alertRef = useRef(null);
    const alertPendRef = useRef(null);

    const handleClickShowAlert = () => {
        setShowAlert(!showAlert)
    };

    const handleClickCloseInfoAlert = () => {
        setShowAlert(!showAlert)
    };

    const handleClickCloseInfoAlertPend = () => {
        setShowAlertPend(!showAlertPend)
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (alertRef.current && !alertRef.current.contains(event.target)) {
                handleClickCloseInfoAlert();
            }
        };

        if (showAlert) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showAlert, handleClickCloseInfoAlert]);

    useEffect(() => {
        const handleClickOutsidePend = (event) => {
            if (alertPendRef.current && !alertPendRef.current.contains(event.target)) {
                handleClickCloseInfoAlertPend();
            }
        };

        if (showAlertPend) {
            document.addEventListener('mousedown', handleClickOutsidePend);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutsidePend);
        };
    }, [showAlertPend, handleClickCloseInfoAlertPend]);

    const renderStepOneText = (text) => {
        if (!text) return null;
        
        const email = 'marketplace@saude360.medis.pt';
        
        if ((title === 'Transferência não autorizada' || title === 'Transferência aceite') && text.includes(email)) {
            const parts = text.split(email);
            return (
                <>
                    {parts[0]}
                    <a href={`mailto:${email}`} className="emailLinkMovementsInfo">
                        {email}
                    </a>
                    {parts[1]}
                </>
            );
        }
        
        return text;
    };
    
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modalMainContainerMovementsInfo"
            fullscreen
        >
            <>
                <div className={ isTablet ? 'modalBtnCloseContainerMovementsInfo' : ( isMobile ? 'modalBtnCloseContainerMovementsInfoTablet' : 'modalBtnCloseContainerMovementsInfoMobile' ) }>
                    <div className="closeIconViewMovementsInfo" onClick={props.onHide}><IoMdClose className="closeIconMovementsInfo"/></div>
                </div>
                <div className={isTablet ? "contentViewMovementsInfo " : (isMobile ? 'contentViewMovementsInfo' : 'contentViewMovementsInfoMobile')}>
                    <div className="titleViewContainerMovementsInfo">
                        { iTransferencia === 'S' ?
                            <div className="mainTitleViewMovementsInfo">{title}</div>
                            :
                            <>
                                { isPending !== 'N' ?
                                    <div className="mainTitleViewMovementsInfo">{title} de saldo</div>
                                :
                                    <div className="mainTitleViewMovementsInfo" >{txtDetalhe?.stepFive}</div>
                                }
                            </>
                        }
                    </div>
                    <div className={isTablet ? 'textViewContainerlMovementsInfo' : (isMobile ? 'textViewContainerlMovementsInfo' : 'textViewContainerlMovementsInfoMobile')}>
                        <div className="titleSmallMovementsInfo ">{date}</div>
                    </div>

                    { isTablet ? (
                    <div className='txtNoMovementViewContainerMovementsInfo'>
                        <span className='textMainInfoMovementsInfo'>{renderStepOneText(movPlataforma === 'MP' ? txtDetalheMP?.stepOne : (txtPromoCode.length === 0 ? txtDetalhe?.stepOne : txtDetalheCupao?.stepOne))}
                            { iTransferencia !== 'S' &&
                                <>
                                    { (title !== 'Dedução' && txtPromoCode.length === 0) &&
                                        <span className='textMainInfoBoldMovementsInfo'> {partnerName}</span>
                                    }
                                    { (txtPromoCode.length === 0 && isPending !== 'C' && movPlataforma !== 'MP') &&
                                        <span className='textMainInfoMovementsInfo'> {txtDetalhe?.stepTwo}</span>
                                    }
                                    { (title !== 'Dedução' && title !== 'Devolução'  && txtPromoCode.length === 0 && movPlataforma !== 'MP') &&
                                        <span className='textMainInfoBoldMovementsInfo'> {title}</span>
                                    }
                                    { (txtPromoCode.length === 0 && movPlataforma !== 'MP') && 
                                        <span className='textMainInfoMovementsInfo'> {txtDetalhe?.stepThree}</span>
                                    }
                                    <span className='textMainInfoBoldMovementsInfo'> {amountAcumulated}€</span>
                                    <span className='textMainInfoMovementsInfo'> {movPlataforma === 'MP' ? txtDetalheMP?.stepFour : (txtPromoCode.length === 0 ? txtDetalhe?.stepFour : txtDetalheCupao?.stepFour)}</span>
                                    { title === 'Acumulação' &&
                                        <span className='textMainInfoBoldMovementsInfo'> {movPlataforma === 'MP' ? movEncomenda : txtPromoCode}</span>
                                    }
                                    { (title === 'Dedução' && movPlataforma === 'MP') &&
                                        <span className='textMainInfoBoldMovementsInfo'> {movEncomenda}</span>
                                    }
                                    { (title === 'Dedução pendente' && movPlataforma === 'MP') &&
                                        <span className='textMainInfoBoldMovementsInfo'> {movEncomenda}</span>
                                    }
                                    { ((movPlataforma === 'MP' && isPending !== 'C') || (movPlataforma === 'MP' && isPending === 'C' && title === 'Dedução pendente')) &&
                                        <span className='textMainInfoMovementsInfo'> {txtDetalheMP?.stepFive}</span>
                                    }
                                </>
                            }
                        </span>
                    </div>
                    ) : (
                        <>
                        <div className="txtNoMovementColumnViewContainerMovementsInfoMobile">
                            <div className='txtNoMovementViewContainerMovementsInfoMobile'>
                                <span className='textMainInfoMovementsInfo'>{renderStepOneText(movPlataforma === 'MP' ? txtDetalheMP?.stepOne : (txtPromoCode.length === 0 ? txtDetalhe?.stepOne : txtDetalheCupao?.stepOne))}
                                    { iTransferencia !== 'S' &&
                                        <>
                                            { (title !== 'Dedução' && txtPromoCode.length === 0) &&
                                                <span className='textMainInfoBoldMovementsInfo'> {partnerName}</span>
                                            }
                                            { (txtPromoCode.length === 0 && isPending !== 'C' && movPlataforma !== 'MP') &&
                                                <span className='textMainInfoMovementsInfo'> {txtDetalhe?.stepTwo}</span>
                                            }
                                            { (title !== 'Dedução' && title !== 'Devolução'  && txtPromoCode.length === 0 && movPlataforma !== 'MP') &&
                                                <span className='textMainInfoBoldMovementsInfo'> {title}</span>
                                            }
                                            { (txtPromoCode.length === 0 && movPlataforma !== 'MP') && 
                                                <span className='textMainInfoMovementsInfo'> {txtDetalhe?.stepThree}</span>
                                            }
                                            <span className='textMainInfoBoldMovementsInfo'> {amountAcumulated}€</span>
                                            <span className='textMainInfoMovementsInfo'> {movPlataforma === 'MP' ? txtDetalheMP?.stepFour : (txtPromoCode.length === 0 ? txtDetalhe?.stepFour : txtDetalheCupao?.stepFour)}</span>
                                            { title === 'Acumulação' &&
                                                <span className='textMainInfoBoldMovementsInfo'> {movPlataforma === 'MP' ? movEncomenda : txtPromoCode}</span>
                                            }
                                            { (title === 'Dedução' && movPlataforma === 'MP') &&
                                                <span className='textMainInfoBoldMovementsInfo'> {movEncomenda}</span>
                                            }
                                            { (title === 'Dedução pendente' && movPlataforma === 'MP') &&
                                                <span className='textMainInfoBoldMovementsInfo'> {movEncomenda}</span>
                                            }
                                            { (movPlataforma === 'MP' && isPending !== 'C') &&
                                                <span className='textMainInfoMovementsInfo'> {txtDetalheMP?.stepFive}</span>
                                            }
                                        </>
                                    }
                                </span>
                            </div>
                        </div>
                        </>
                    )}

                    <div className="infoViewContainerMovementsInfo">
                        <div className="txtInfoTitleViewContainerMovementsInfo ">
                            { iTransferencia === 'S' ?
                                <div className="titleViewMovementsInfo">{title}</div>
                                : (
                                    <>
                                        { isPending !== 'N' ?
                                            ( (txtPromoCode.length === 0 && isPending !== 'C' && partnerName.length !== 0) ?
                                                <div className="titleViewMovementsInfo">{title} de saldo - <span className='titleRegularMovementsInfo'>{partnerName}</span></div>
                                                :
                                                ( movPlataforma !== 'MP' ?
                                                    <div className="titleViewMovementsInfo">{title} de saldo</div>
                                                    :
                                                    <div className="titleViewMovementsInfo">{title} de saldo - Marketplace Médis</div>
                                                )
                                            )
                                            
                                        :
                                            ( partnerName.length !== 0 ?
                                                <div className="titleViewMovementsInfo">{txtDetalhe?.stepFive} - <span className='titleRegularMovementsInfo'>{partnerName}</span></div>
                                                :
                                                <div className="titleViewMovementsInfo">{txtDetalhe?.stepFive}</div>
                                            )
                                        }
                                    </>
                                )
                            }
                        </div>
                            <div className="txtNoMovementRowViewContainerMovementsInfo">
                                <div className="txtNoMovementColunmViewContainerMovementsInfo">
                                { iTransferencia === 'S' ?
                                        <div className="textMovementsInfo" >Valor</div>
                                        : (
                                            <>
                                                { txtPromoCode.length === 0 &&
                                                    ( (movPlataforma === 'MP' && title !== 'Expiração') ?
                                                        <div className="textMovementsInfo" >Valor da encomenda</div>
                                                    :
                                                        <div className="textMovementsInfo" onClick={handleClickShowAlert} >Valor pago <IoMdInformationCircleOutline className="iconInfoModalMovementsInfo"/></div>
                                                    )
                                                }
                                                { title !== 'Expiração' && (
                                                    (isPending !== 'C') ?
                                                        <div className="textMovementsInfo">{ movPlataforma === 'MP' ? ( title !== 'Dedução' ? 'Saldo devolvido' : 'Saldo gasto') : 'Valor acumulado'}</div>
                                                        :
                                                        <div className="textMovementsInfo">{ movPlataforma !== 'MP' ? 'Valor deduzido' : 'Saldo gasto'}</div>
                                                )}
                                                { showAlert &&
                                                    <div className='alertInfoMainViewSeeMovementsInfo' ref={alertRef}  onClick={handleClickCloseInfoAlert}>
                                                        <div className='mainViewAlerSmModalSeeMovementsInfo'>
                                                            <div className='txtTitleAlerSmModalSeeMovementsInfo'>Valor pago</div>
                                                            <div className='txtAlerSmModalSeeMovementsInfo'>Valor total da compra que fez no parceiro.</div>
                                                        </div>
                                                    </div>
                                                }
                                            </>
                                        )
                                    }
                                </div>
                                <div className="txtNoMovementSaldoColunmViewContainerMovementsInfo ">
                                    { (txtPromoCode.length === 0 && iTransferencia !== 'S') &&
                                        <div className='textBoldMovementsInfo'> {amountPaid}€</div>
                                    }
                                    { title !== 'Expiração' &&
                                        <div className='textBoldMovementsInfo'> {amountAcumulated}€</div>
                                    }
                                </div>
                            </div>
                    </div>
                    { (isPending === 'N' && iTransferencia !== 'S') && (
                    <div className="infoSecondViewContainerMovementsInfo">
                        <div className="txtNoMovementRowViewContainerMovementsInfo">
                            <div className="textSubTitleMovementsInfo">Estado</div>
                            <div className='mainModalInfoStatusDataBoxViewMovementsInfo'  onClick={handleClickCloseInfoAlertPend}>
                                <div className='iconModalInfoStatusDataBoxMovementsInfo'><GoDotFill /></div>
                                <div className='textSecondaryMovementsInfo'>Acumulação pendente</div>
                                <div className='iconInfoViewModalInfoStatusDataBoxMovementsInfo'>
                                    <IoMdInformationCircleOutline className='iconInfoModalInfoStatusDataBoxMovementsInfo' />
                                </div>
                            </div>
                            { showAlertPend &&
                                <div className='alertInfoMainViewPendSeeMovementsInfo' ref={alertPendRef}  onClick={handleClickCloseInfoAlertPend}>
                                    <div className='mainViewAlerSmModalSeeMovementsInfo'>
                                        <div className='txtTitleAlerSmModalSeeMovementsInfo'>Acumulação pendente</div>
                                        <div className='txtAlerSmModalSeeMovementsInfo'>Este valor estará disponível no seu saldo nas próximas 48 horas.</div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    )}
                    <div className={ isTablet ? "btnViewMovementsInfo" : (isMobile ? "btnViewMovementsInfo" : "btnViewMovementsInfoMobile")}>
                        <CustomButton 
                            text={'Compreendi'} 
                            color={'#15D4B6'}
                            textColor={'#00214D'}
                            onPress={props.onHide}
                        />
                    </div>
                </div>
            </>
        </Modal>
    );
};

export default CustomModalMovementsInfo;